<!--
DOC
pagina visual builder
gestione paramentri comuni con vuex


1 zona dialog con i dialog :
-render con modulo specifico (vedere Renderer.vue)
-salvataggio modulo custom
-edit css modulo


2 zona lista elementi (span 8):
lista degli elementi presi da builder-store,
struttura tipo di un elemento
{ name: "casella di testo", id: 0, hasChildren: 0, value: "", type: "text", setting:BASESETTINGS },
tutto obbligatorio tranne setting, in base se si vuole o no la modifica css



3 zona anteprima pagina:
divisa a sua volta in tre zone draggabili fa riferimento allo stesso super array per la definizione dell'albero
gli elementi vengono draggati dall'area precedente dentro una delle tre e possono essere spostati tra queste senza problemi

-->
<template>
	<el-row style="overflow-y: auto; overflow-x: hidden; width: 100%" :style="{ height: heightscreen + 'px' }">
		<!--    dialog di render -->
		<el-dialog :title="$t('preview')" :visible.sync="dialogVisible" width="80%">
			<renderer v-if="dialogVisible" :dati="list2"></renderer>
			<el-button type="primary" @click="dialogVisible = false">chiudi</el-button>
		</el-dialog>
		<!--    dialog di salvataggio elemento-->
		<el-dialog
			:title="$t('save-new-block')"
			:visible.sync="showInsert"
			width="30%"
			:close-on-click-modal="false"
			@close="hideModalInsert()"
		>
			<el-input v-model="toinsert.name"></el-input>
			<el-button
				type="primary"
				@click="
					toinsert.ref_id = addElement()
					hideModalInsert()
				"
				>Salva</el-button
			>
			<el-button type="primary" @click="hideModalInsert()">Chiudi</el-button>
		</el-dialog>
		<!--    dialog modifica css -->

		<el-dialog v-if="toedit" :title="$t('edit')" :visible.sync="showEdit" width="60%">
			<css-modal v-if="showEdit"></css-modal>
		</el-dialog>

		<!--    corpo pagina -->
		<el-col :key="'bbb'" style="margin: 5px" :span="24">
			<div class="grid-content bg-purple-light">
				<div style="display: flex">
					<h3>{{ selected_node ? selected_node.titolo : "Nodo" }}</h3>
					<el-button type="danger" style="height: min-content; margin: 20px" @click="closeEditor"
						>X
					</el-button>
				</div>
				<el-tooltip class="item" effect="dark" :content="$t('paste')" placement="top-start">
					<el-button class="_btn" v-if="cut" @click="pasteAt(list2[0].items, -1)" circle>
						<md-icon>content_paste</md-icon>
					</el-button>
				</el-tooltip>
				<div v-for="(section, ids) in list2">
					<draggable
						:scroll-sensitivity="200"
						:force-fallback="true"
						:list="section.items"
						class="list-group"
						:options="dragOptionsInside"
						:empty-insert-threshhold="500"
						handle=".handle"
						style="
							min-height: 100px !important;
							min-width: 60px;
							border: 1px dotted black;
							width: 95%;
							padding: 10px;
							margin: 10px;
						"
					>
						<!--
						DOC

						la card rappresenta l'oggetto draggato in un'area
						il primo livello (questo) non è stato inserito utilizzando subcomponents.vue come gli altri perchè era progettato diversamente.
						con un piccolo refactor può essere possibile integrarlo e sostituirlo

						comprende:
						-icona di drag dell'elemento
						-nome dell'elemento (che funge da drag)
						-tasti edit, save, clone, delete che triggerano le rispettive azioni


						-->

						<el-card
							:style="{ border: section.items[idx].ref_id !== undefined ? '4px solid #409eff' : 'none' }"
							class="box-card"
							v-for="(element, idx) in section.items"
							:key="element.id + idx"
						>
							<div style="width: 100%; height: auto; min-height: 60px">
								<md-icon class="handle" style="float: left">open_with</md-icon>
								<div style="float: left">
									&nbsp;

									<el-badge
										v-if="section.items[idx].ref_id !== undefined"
										:value="$t('saved-block')"
										class="item"
										type="primary"
									>
										<div style="max-width: 600px; overflow: hidden">{{ element.name }}</div>
									</el-badge>
									<div style="display: inline" v-else>{{ element.name }}</div>
									<div style="display: inline" v-on:dblclick="copIE(element.wiki)">
										<el-tooltip
											v-if="element.wiki"
											style="border: none; width: 25px; left: 90px; position: relative"
											class="item"
											effect="dark"
											:content="element.wiki"
											placement="top"
										>
											<md-icon>help_outline</md-icon>
										</el-tooltip>
									</div>
								</div>

								<el-tooltip
									class="item"
									effect="dark"
									:content="$t('delete')"
									placement="top-start"
									:open-delay="500"
								>
									<el-button class="_btn" @click="removeAt(ids, idx)" circle>
										<md-icon>delete</md-icon>
									</el-button>
								</el-tooltip>
								<el-tooltip
									class="item"
									effect="dark"
									:content="$t('clone')"
									placement="top-start"
									:open-delay="500"
								>
									<el-button
										class="_btn"
										@click="cloneAt(list2[ids].items, idx)"
										circle
										style="margin-right: 10px"
									>
										<md-icon>content_copy</md-icon>
									</el-button>
								</el-tooltip>
								<el-tooltip
									class="item"
									effect="dark"
									:content="$t('cut')"
									placement="top-start"
									:open-delay="500"
								>
									<el-button class="_btn" v-if="!cut" @click="cutAt(list2[ids].items, idx)" circle>
										<md-icon>content_cut</md-icon>
									</el-button>
								</el-tooltip>
								<el-tooltip
									class="item"
									effect="dark"
									:content="$t('paste')"
									placement="top-start"
									:open-delay="500"
								>
									<el-button class="_btn" v-if="cut" @click="pasteAt(list2[ids].items, idx)" circle>
										<md-icon>content_paste</md-icon>
									</el-button>
								</el-tooltip>

								<el-tooltip
									class="item"
									effect="dark"
									:content="$t('save-as-new-block')"
									placement="top-start"
									:open-delay="500"
								>
									<el-button
										class="_btn"
										v-if="section.items[idx].ref_id === undefined"
										@click="saveEl(section.items[idx])"
										circle
									>
										<md-icon>save</md-icon>
									</el-button>
								</el-tooltip>
								<el-tooltip
									class="item"
									effect="dark"
									:content="$t('edit-style')"
									placement="top-start"
									:open-delay="500"
								>
									<el-button
										class="_btn"
										v-if="section.items[idx].ref_id === undefined"
										@click="editEl(section.items[idx])"
										circle
									>
										<md-icon>edit</md-icon>
									</el-button>
								</el-tooltip>
								<el-tooltip
									class="item"
									effect="dark"
									:content="$t('edit-as-single-blocks')"
									placement="top-start"
									:open-delay="500"
								>
									<el-button
										class="_btn"
										v-if="section.items[idx].ref_id !== undefined"
										@click="editElAsBlock(section.items[idx])"
										circle
									>
										<md-icon>post_add</md-icon>
									</el-button>
								</el-tooltip>
							</div>
							<!--
							DOC

							reflect component renderezza in preview l'effettivo elemento interessato dal drag (casella di testo, editor, immagine ecc)
							e se necessario gli elementi figli (per esempio sulle righe)

							-->

							<reflect-component
								:is-editable="section.items[idx].ref_id === undefined"
								:key="element.id + 'subelements'"
								:element="element"
							></reflect-component>
						</el-card>
					</draggable>
				</div>
			</div>
		</el-col>
	</el-row>
</template>
<script>
import draggable from "vuedraggable"
import Subcomponents from "@/modules/builder/components/subcomponents"
import BuilderElement from "@/modules/builder/builder-element"
import ReflectComponent from "@/modules/builder/Reflect/reflect-component"
import rawDisplayer from "@/modules/builder/components/raw-displayer"
import { clone, cloneAt, uuid } from "@/modules/builder/utils/utils"
import Renderer from "@/modules/builder/components/Renderer"
import { mapActions, mapGetters, mapMutations } from "vuex"
import HowToUse from "@/modules/builder/components/how-to-use"
import CssModal from "@/modules/builder/components/css-modal"

let id = 1
export default {
	name: "visual-builder",
	display: "Simple",
	order: 0,
	components: {
		CssModal,
		HowToUse,
		Renderer,
		ReflectComponent,
		Subcomponents,
		rawDisplayer,
		BuilderElement,
		clone,
		cloneAt,
		uuid,
		draggable
	},

	data() {
		return {
			enabled: true,
			heightscreen: window.innerHeight - 55,
			dialogVisible: false,
			dragging: false,

			useless: 0
		}
	},
	computed: {
		showEdit: {
			get() {
				return this.showEdit_state
			},
			set(el) {
				if (el) {
					this.show_edit()
				} else {
					this.hide_edit()
				}
			}
		},
		selected_node() {
			/**/
			//var ind = this.nodes.findIndex(i => i.id == this.selected_node_id)
			return this.node_value(this.selected_node_id)
		},
		list2: {
			get() {
				var ind = this.nodes.findIndex(i => i.id == this.selected_node_id)
				if (ind !== -1) return this.node_value_builder(ind)
			},
			set(val) {
				this.editNodeValue({ node_id: this.selected_node_id, val: val })
			}
		},
		...mapGetters({
			nodes: "flowchart/nodes",
			toinsert: "builder/toinsert",
			toedit: "builder/toedit",
			showInsert: "builder/showInsert",
			showEdit_state: "builder/showEdit",
			selectOptions: "builder/selectOptions",
			node_value_builder: "flowchart/node_value_builder",
			selected_node_id: "flowchart/showModalEdit",
			node_value: "flowchart/node_value",
			cut: "builder/cut"
		}),
		/**
		 * DOC
		 * nei due computed sotto vbengono definite le proprietà per le aree drag della pagina, far riferimento alla documentazione di vuedraggable per i dettagli
		 *
		 *
		 *
		 *selected_node
		 * ps: ghostClass dragClass chosenClass definiscono gli
 attributi css per l'elemento quando è nello stato di "trascinamento" e la sua "ombra"
		 * */
		ListOptions() {
			return {
				group: {
					name: "items",
					pull: "clone",
					put: false
				},
				sort: false,
				disabled: !this.enabled,
				ghostClass: "ghostCustom",
				dragClass: "ghostCustom",
				chosenClass: "dragCustomClass",

				animation: 200
			}
		},
		dragOptionsInside() {
			return {
				group: {
					name: "items"
				},
				sort: true,
				disabled: !this.enabled,
				ghostClass: "ghostCustom",
				dragClass: "ghostCustom",
				chosenClass: "dragCustomClass",
				animation: 200
			}
		}
	},
	methods: {
		copIE(value) {
			/* Copy the text inside the text field */
			navigator.clipboard.writeText(value)

			/* Alert the copied text */
		},

		uuid,
		...mapActions({
			addElement: "builder/addElement",
			editInsert: "builder/editInsert",
			editEdit: "builder/editEdit",
			showModalInsert: "builder/showModalInsert",
			hideModalInsert: "builder/hideModalInsert",
			hideModalEdit: "builder/hideModalEdit",
			showModalEdit: "builder/showModalEdit",
			editNodeValue: "flowchart/editNodeValue",
			editModalEdit: "flowchart/editModalEdit",
			setCut: "builder/setCut",
			resetCut: "builder/resetCut"
		}),
		...mapMutations({
			show_edit: "builder/SHOW_EDIT",
			hide_edit: "builder/HIDE_EDIT"
		}),
		async cutAt(list, id) {
			await this.setCut(list[id])
			list.splice(id, 1)
		},
		async pasteAt(list, id) {
			list.splice(id + 1, 0, this.cut)
			await this.resetCut()
		},
		saveEl(el) {
			/**
			 * DOC
			 * inserisce un nuovo elemento custom basato su quello attuale,
			 * la funzione clone e l'id randomico garantiscono la separazione del clone dal padre
			 * per ulteriori dettagli, vedere lo store
			 *
			 * poi apre il modale per il nome
			 *
			 * */
			var toinsertel = el
			toinsertel.name += "(salvato)"
			toinsertel.id = Math.random().toString(16).slice(2)
			this.editInsert(toinsertel)
			this.showModalInsert()
		},
		editEl(el) {
			/**
			 * DOC
			 * trigger l'edit css dell'elemento
			 * */
			this.editEdit(el)
			this.showModalEdit()
		},
		editElAsBlock(el) {
			/**
			 * DOC
			 * trigger l'edit css dell'elemento come blocco perchè lui è bloccato ma vabbè ok
			 *
			 * */
			this.$confirm(this.$t("warning-edit-shared-block"), "Attenzione", {
				confirmButtonText: "OK",
				cancelButtonText: "Cancel",
				type: "warning"
			})
				.then(() => {
					el.ref_id = undefined
				})
				.catch(() => {})
		},
		cloneAt(a, b) {
			cloneAt(a, b)
		},
		clone(a) {
			return clone(a)
		},
		removeAt(section, idx) {
			this.list2[section].items.splice(idx, 1)
		},
		closeEditor() {
			this.editModalEdit({ val: false, id: undefined })
		}
	}
}
</script>
<style scoped>
.button {
	margin-top: 35px !important;
}

.flip-list-move {
	transition: transform 0.5s !important;
}

.no-move {
	transition: transform 0s !important;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb !important;
}

.list-group {
	min-height: 20px !important;
}

.list-group-item {
	cursor: move !important;
}

.list-group-item i {
	cursor: pointer !important;
}
</style>
<style>
.freccia-altezza > input {
	padding: 0 !important;
}

._btn {
	position: relative;
	width: min-content;
	float: right;
	margin: 5px;
	padding: 3px;
}

.drawflow .drawflow-node {
	display: block;
}

.drawflow .drawflow-node .inputs,
.drawflow .drawflow-node .outputs {
	display: flex;
	width: auto;
	display: flex;
	justify-content: center;
	align-items: center;
}

.drawflow .drawflow-node .input {
	top: -10px;
	left: 0px;
}

.drawflow .drawflow-node .output {
	top: 10px;
	right: 0px;
}

.dragCustomClass {
	background-color: red;
	max-height: 63px;
}

.ghostCustom {
	height: auto;
	background-color: green;
}
</style>
